import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TaxSitesComponent } from './components/tax-sites/tax-sites.component';
import {RouterModule} from "@angular/router";
import {TaxSitesRoutes} from "./orbitax-tax-sites.routes";
import {SharedModule} from "@shared/shared.module";
import {TaxSitesService} from "./services/tax-sites.service";
import {CommandService} from '@core/services/command.service';
import {PlatformCommand} from '@shared/commands/command-base';
import {Api} from '@shared/constants/common-field.constants';
import {PlatformApiProvider} from '@shared/services/platform-api-provider';
import {TaxSitesDynamicComponentHelper} from '@features/tax-sites/tax-sites-dynamic-component-helper';

@NgModule({
  declarations: [TaxSitesComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(TaxSitesRoutes),
    SharedModule
  ],
  providers: [TaxSitesService]
})
export class OrbitaxTaxSitesModule {
  constructor(private commandService: CommandService,
              private platformApiProvider: PlatformApiProvider,
              ) {
    TaxSitesDynamicComponentHelper.init();
    const TaxSitesCommand = new PlatformCommand('TaxSitesToolLinkCommand', Api.ITRCE);
    this.commandService.registrPlatformLinkCommand('/itrce/tax-sites', TaxSitesCommand);
  }
}
